import React from 'react';

import { useRoleShowState, useRoleShowActions } from './RoleShowContext';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { addUserToRole } from './restApi';

const AddUserToRoleForm = ({ role }) => {
  const state = useRoleShowState();
  const { onResponse, onError, updateNewUserId, closeAddUserToRoleModal } = useRoleShowActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    addUserToRole({
      role,
      onResponse,
      onError,
      body: {
        newUser: state?.newUser,
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="User ID" id="userId">
        <Input
          type="text"
          value={state?.newUser?.id || ''}
          onChange={(e) => {
            updateNewUserId(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeAddUserToRoleModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Add User
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default AddUserToRoleForm;
